/* eslint-disable react/no-unused-prop-types */
import { ReactComponent as AirplaneIcon } from '../../../assets/airplane.svg';
import { ReactComponent as ShipIcon } from '../../../assets/ship.svg';
import { ReactComponent as RocketIcon } from '../../../assets/rocket.svg';
import { ReactComponent as CarIcon } from '../../../assets/car.svg';
import { client, WLClient } from '../../../config';
import Tag, { TagColor } from '../../../common/tag/tag.component';
import { TagContent } from './delivery-option-card.styles';
import { DeliveryMethod } from '../../../models/delivery-options/common';

const getTagColor = () => {
  const colors: Record<WLClient, TagColor> = {
    meest: 'blue',
    polonez: 'polonez',
  };
  return colors[client];
};

export const getMiddleMileIcon = (method: DeliveryMethod) =>
  (
    ({
      air: <AirplaneIcon />,
      car: <CarIcon />,
      sea: <ShipIcon />,
      expedited: <RocketIcon />,
    }) as const
  )[method];

const getTagData = (method: DeliveryMethod) =>
  (
    ({
      air: {
        tagColor: getTagColor(),
        icon: getMiddleMileIcon(method),
      },
      car: {
        tagColor: getTagColor(),
        icon: getMiddleMileIcon(method),
      },
      sea: {
        tagColor: getTagColor(),
        icon: getMiddleMileIcon(method),
      },
      expedited: {
        tagColor: 'red',
        icon: getMiddleMileIcon(method),
      },
    }) as const
  )[method];

interface Props {
  deliveryMethod: DeliveryMethod;
  staticTimeString: string;
  isExpanded?: boolean;
  postfix?: string;
}

export const MiddleMileTag = ({
  deliveryMethod,
  staticTimeString,
  postfix,
}: Props) => {
  const { tagColor } = getTagData(deliveryMethod);

  const tag = (
    <Tag
      type='semi-filled'
      color={tagColor}
      size='small'>
      <TagContent>
        <p>
          {staticTimeString}
          {postfix}
        </p>
      </TagContent>
    </Tag>
  );

  return tag;
};
